import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import { AppBarWithActionButtons } from '../../../../components/designe/app-bars/app-bar-with-buttons/AppBarWithActionButtons';
import AppProgramCollectionAvatar from '../../../../components/designe/app-entity-avatar/app-program-collection-avatar/AppProgramCollectionAvatar';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import ConfirmDialog from '../../../../components/reusable/confirm-dialog/ConfirmDialog';
import ViewField from '../../../../components/reusable/view-field/ViewField';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import {
  useDeletePrograms,
  useGetProgramCollectionById,
} from '../../../../redux/api/programsAPI';
import { AvatarSize } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import { useStyles } from './ProgramCollectionDetails.styles';

function ProgramCollectionDetails(props) {
  const { programId } = props;
  const { t } = useTranslation();
  const {
    data: programCollection,
    isFetching,
    isLoading,
    error,
    refetch,
  } = useGetProgramCollectionById(programId);
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const [deleteProgram] = useDeletePrograms();
  const { back, navigate } = useNavigationStack();
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isLoading || isFetching,
    hasData: Boolean(programCollection),
    onRetry: handleRetry,
  });

  // const [planDialogOpened, setPlanDialogOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  function onEditClick() {
    navigate(Paths.programs.toEditCollectionId(programId));
  }

  return (
    <Box title={t('programs.programCollection')}>
      <Box className={classes.programCollectioWrapper}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          gap={1}
          minWidth={0}>
          <Typography variant="h1" className={classes.programCollectionTitle}>
            {programCollection?.title}
          </Typography>
          <Box display="flex" gap={0.5} flexShrink={0}>
            {programCollection?.permissions?.canEdit && (
              <EditActionButton onClick={onEditClick} />
            )}
            {programCollection?.permissions?.canDelete && (
              <DeleteActionButton onClick={() => setDeleteConfirm(true)} />
            )}
          </Box>
        </Box>
        {programCollection?.description && (
          <ViewField
            value={programCollection.description}
            label={t('common.description')}
          />
        )}
        <Box display="flex" flexDirection="column" gap={0.5} marginTop={1}>
          <Typography variant={'label-text-sm'}>
            {t('common.avatar')}
          </Typography>
          <AppProgramCollectionAvatar
            programCollection={programCollection}
            size={AvatarSize.l}
          />
        </Box>
      </Box>
      <ConfirmDialog
        open={!!deleteConfirm}
        onClose={() => setDeleteConfirm(null)}
        title={t('common.delete')}
        onSubmit={() =>
          deleteProgram({ id: programCollection.id })
            .unwrap()
            .then(() => {
              back();
              setDeleteConfirm(false);
            })
            .catch((e) => console.log(e))
        }>
        {t('common.deleteQuestion')}
      </ConfirmDialog>
    </Box>
  );
}

export default ProgramCollectionDetails;
